module.exports = {"pipeline":{"name":"pipeline-singleChoiceQuestion","title":"单选题","type":"qs-choice","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-singleChoiceQuestion/package.json
// module id = 589
// module chunks = 2